import VideoModal from "./video-modal";
import Video from "./video";

export default class VideoResult {

    constructor(root) {
        this.container = root;
        this.modalRoot = this.container.querySelector('.video-modal');
        this.playButton = this.container.querySelector('.overlay');
        this.link = this.container.querySelector('a');
        this.copy = this.container.querySelector('p');

        this.video = new Video(this.modalRoot.querySelector('.video-container'));

        this.videoModal = new VideoModal(this.modalRoot);
        this.videoModal.onClose = () => {
            if(this.video.player && this.video.player.playing) {
                this.video.player.stop();
            }
        }

        this.playButton.addEventListener('click', () => this.videoModal.handleOpenClick(this.modalRoot));
        this.copy.addEventListener('click', () => this.videoModal.handleOpenClick(this.modalRoot));
        this.link.addEventListener('click', e => {
            e.preventDefault();
            this.videoModal.handleOpenClick(this.modalRoot);
        });
    }
}